import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { getUserDataFromToken } from "../Utils/urlAuthHandler";

const ProtectedRoute = () => {
  const [userAllow, setUserAllow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const { isAuthenticated } = getUserDataFromToken();
      setUserAllow(true);

    if (isAuthenticated) {
      setUserAllow(true);
    } else {
      window.location.href = "https://people.oruclick.com/";
    }

  }, [navigate]);

  return userAllow ? <Outlet /> : null; // Show the page only if authenticated
};

export default ProtectedRoute;
